/* eslint-disable react/no-array-index-key */
import React from "react";

import { Col, Row } from "react-bootstrap";

import { provinceOptions } from "components/calculations/utils/regionNames";
import SelectField from "components/common/inputs/Select/SelectField";
import TextInput from "components/common/inputs/TextInput";

const LawyerFormInputs = ({ clientLoading, createLoading, updateLoading }) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={6}>
          <TextInput
            name="orgName"
            label="Organization Name"
            placeholder="Organization Name"
            disabled={clientLoading || createLoading || updateLoading}
          />
        </Col>
        <Col xs={6}>
          <TextInput
            name="location.country"
            label="Country"
            placeholder="Country"
            disabled={clientLoading || createLoading || updateLoading}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <SelectField
            name="location.residence"
            label="Province"
            placeholder="Select Residence"
            containerClassName="mb-3"
            disabled={clientLoading || createLoading || updateLoading}
            options={provinceOptions.filter((p) => p.value !== "CDN")}
          />
        </Col>
        <Col xs={6}>
          <TextInput
            name="location.city"
            label="City"
            placeholder="City"
            disabled={clientLoading || createLoading || updateLoading}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <TextInput
            name="location.street1"
            label="Address Line"
            placeholder="Address Line"
            disabled={clientLoading || createLoading || updateLoading}
          />
        </Col>
        <Col xs={6}>
          <TextInput
            name="location.street2"
            label="Address Line 2"
            placeholder="Address Line 2"
            disabled={clientLoading || createLoading || updateLoading}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <TextInput
            name="location.postal"
            label="Postal Code"
            placeholder="Postal code or Zip Code"
            disabled={clientLoading || createLoading || updateLoading}
          />
        </Col>
        <Col xs={6}>
          <TextInput
            name="location.fax"
            label="Fax"
            placeholder="01-2345-6789"
            disabled={clientLoading || createLoading || updateLoading}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <TextInput
            name="location.email"
            label="Email"
            placeholder="Email"
            type="Email"
            disabled={clientLoading || createLoading || updateLoading}
          />
        </Col>
        <Col xs={6}>
          <TextInput
            name="location.phone"
            label="Phone Number"
            placeholder="+1-234-567-8900"
            disabled={clientLoading || createLoading || updateLoading}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default LawyerFormInputs;
